import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from '~src/spacesPlatform/models/sort/SortOptionsHelper';

import { OrderKeys } from '../../../spacesPlatform/models/OrderKeys';

export const siteSortOptions: OptionsDictionary = {
  'createdAt': SortOptions.createdAt,
  'name': SortOptions.name,
  'adminCount': createNonDisplayOptionDefinition('adminCount', OrderKeys.adminCount),
  'userCount': createNonDisplayOptionDefinition('userCount', OrderKeys.userCount),
  'authoringEnabled': createNonDisplayOptionDefinition('authoringEnabled', OrderKeys.authoringEnabled),
  'availability': createNonDisplayOptionDefinition('availability', OrderKeys.availability),
  'currentLoggedInUserCount': createNonDisplayOptionDefinition('currentLoggedInUserCount', OrderKeys.currentLoggedInUserCount),
  'extractEncryptionMode': createNonDisplayOptionDefinition('extractEncryptionMode', OrderKeys.extractEncryptionMode),
  'guestAccessEnabled': createNonDisplayOptionDefinition('guestAccessEnabled', OrderKeys.guestAccessEnabled),
  'metricsEnabled': createNonDisplayOptionDefinition('metricsEnabled', OrderKeys.metricsEnabled),
  'sheetImageEnabled': createNonDisplayOptionDefinition('sheetImageEnabled', OrderKeys.sheetImageEnabled),
  'siteAdminsCanAddUsers': createNonDisplayOptionDefinition('siteAdminsCanAddUsers', OrderKeys.siteAdminsCanAddUsers),
  'storageUsedBytes': createNonDisplayOptionDefinition('storageUsedBytes', OrderKeys.storageUsedBytes),
  'storageQuotaBytes': createNonDisplayOptionDefinition('storageQuotaBytes', OrderKeys.storageQuotaBytes),
  'storageQuotaPercentUsed': createNonDisplayOptionDefinition('storageQuotaPercentUsed', OrderKeys.storageQuotaPercentUsed),
  'urlName': createNonDisplayOptionDefinition('urlName', OrderKeys.urlName),
  'userQuota': createNonDisplayOptionDefinition('userQuota', OrderKeys.userQuota),
};
